import { Component, EventEmitter, OnInit } from '@angular/core';
import {
  DwButtonCommand,
  DwButtonConfig,
  DwModalConfig,
  DwModalHandler,
  DwModalResult
} from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import {
  UnitMemberPdfOptionsModalData,
  UnitMemberPdfOptionsModalResult,
  UnitMemberPdfSectionOption
} from '../../models/unit-member-pdf.model';

@Component({
  selector: 'app-unit-member-pdf-options-modal',
  templateUrl: './unit-member-pdf-options-modal.component.html',
  styleUrls: ['./unit-member-pdf-options-modal.component.scss']
})
export class UnitMemberPdfOptionsModalComponent implements OnInit, DwModalHandler {
  modalConfig: DwModalConfig<UnitMemberPdfOptionsModalData>;
  closeModal = new EventEmitter<DwModalResult<UnitMemberPdfOptionsModalResult>>();
  sections: UnitMemberPdfSectionOption[] = [];
  selectedMode: 'all' | 'selected' = 'all';
  selected: { [code: string]: boolean } = {};

  ngOnInit(): void {
    this.sections = (this.modalConfig.data.sections || []).sort((a, b) => a.SortOrder - b.SortOrder);
    this.sections.forEach(section => this.selected[section.Code] = true);
  }

  buttonClick(button: DwButtonConfig): Observable<DwModalResult<UnitMemberPdfOptionsModalResult>> {
    const result = new DwModalResult<UnitMemberPdfOptionsModalResult>();
    if (button.command === DwButtonCommand.cancel) {
      result.cancelled = true;
      result.closeModal = true;
      return of(result);
    }

    if (button.command === DwButtonCommand.ok || button.command === DwButtonCommand.save ||
      button.command === DwButtonCommand.saveAndClose) {
      const sectionCodes = this.selectedMode === 'all'
        ? []
        : this.sections.filter(section => this.selected[section.Code]).map(section => section.Code);
      if (this.selectedMode === 'selected' && sectionCodes.length === 0) {
        result.closeModal = false;
        return of(result);
      }
      result.data = { sectionCodes };
      result.closeModal = true;
    }
    return of(result);
  }

  hasSelection(): boolean {
    return this.sections.some(section => this.selected[section.Code]);
  }
}
